import React from 'react';
import ReactDOM from 'react-dom/client';

import Home from './components/home/Home';

import './index.css';
import 'bulma/css/bulma.min.css';

import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'
import { BrowserRouter, Route, Routes } from 'react-router';
import Layout from './components/commons/Layout';
import Order from './components/order/Order';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout/>}>
          <Route index element={<Home />} />
          <Route path="/" element={<Home />} />
          <Route path="/order" element={<Order />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);